import { Component, OnInit, Input, Injector, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { MainComponent } from '../main-component/main.component';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-resource-banner',
    templateUrl: './resource-banner.component.html',
    styleUrls: ['./resource-banner.component.scss'],
    standalone: false
})
export class ResourceBannerComponent extends MainComponent implements OnInit {
  @Input() bannerJson: any;
  bannerFields: any;
  cardData: any;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  @Output() patientResult = new EventEmitter<any>();
  @Output() footerLinksClick = new EventEmitter<any>();
  dataForCard: any = [];

  constructor(
    public injector: Injector,
    private route: ActivatedRoute,
    public viewContainerRef: ViewContainerRef,
    public commonService?: CommonService
  ) {
    super(injector, route);
  }
  ngAfterViewInit() {
    console.log("this.bannerJson.resourceNamethis.bannerJson.resourceName", this.bannerJson);
    if (this.bannerJson && this.bannerJson.name != undefined) {
      Promise.resolve(null).then(() =>
        this.baseService.getResourceDef(this.bannerJson.name, (resp) => {
          this.bannerFields = resp.card;
          this.getData();
        }));
    } else if (this.bannerJson && this.bannerJson.jsonName != undefined) {
      Promise.resolve(null).then(() =>
        this.baseService.getResourceDef(this.bannerJson.jsonName, (resp) => {
          this.bannerJson.jsonFields = resp.card;
          this.bannerJson.supportingFields = resp.supporting_banner;
          this.bannerJson.resouceDef=resp;
          this.getData();
        }));
    } else {
      this.getData();
    }
    if (this.bannerJson.shouldInfoDisplay == true && !this.bannerJson.name && !this.bannerJson.jsonFields && this.bannerJson?.additionalResource) {
      this.addInfoForBannerWithoutResourceDef(this.bannerJson.additionalResource)
    }
  }
  
  addInfoForBannerWithoutResourceDef(additionalJsonName) {
    this.bannerJson.resouceDef = {}
    this.baseService.getResourceDef(additionalJsonName, (resp) => {
      this.bannerJson.resouceDef = resp;
    });
  }

  getParamValueQueryString(paramName, callback) {
    if (this.route.snapshot.queryParams.key == undefined) {
      const url = window.location.href;
      let paramValue;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        paramValue = httpParams.get(paramName);
      }
      if (paramValue != null)
        callback(paramValue);
      else
        callback(false);
    } else {
      callback(this.route.snapshot.queryParams.key)
    }
  }

  getData() {
    if (this.bannerJson && this.bannerJson.hasOwnProperty('key')) {
      this.cardData = this.bannerJson.key;
      if (this.bannerJson.name != undefined) {
        /********************ACCOUNT AWARE  *************/
        //TODO
        /********************ACCOUNT AWARE  *************/

        this.extractData();
        //added so tht banner info can be accessed further
        this.commonService.setBanner(this.bannerJson, this.cardData);
      } else {
        /********************ACCOUNT AWARE  *************/
        //TODO
        /********************ACCOUNT AWARE  *************/

        this.dataForCard.push(this.cardData);
        this.getCustomComponent();
        console.log("Element is ", this.dataForCard);
        //added so tht banner info can be accessed further
        this.commonService.setBanner(this.bannerJson, this.cardData);
        // this.patientResult.emit(this.cardData);
      }
    } else if (this.route.snapshot.queryParams.hasOwnProperty('key')) {
      this.getParamValueQueryString('key', (response) => {
        if (response) {
          var id = response;
          if (this.route.snapshot.queryParams.query_params)
            this.bannerJson.datasource['args'] = this.route.snapshot.queryParams.query_params;
          else if (this.bannerJson.datasource['args'] == undefined)
            this.bannerJson.datasource['args'] = "id:" + id;
          else if (this.bannerJson.datasource['args'] != undefined && this.bannerJson.datasource['args'].includes('!!!')) {
            this.bannerJson.datasource['args'] = this.baseService.buildDyanamicStr(this.bannerJson.datasource['args'], { data: this.route.snapshot.queryParams })
          } else {
            this.bannerJson.datasource['args'] = this.bannerJson.datasource['args'] + ",id:" + id;
          }
          this.getDataFn();
        }
      });
    } else if (this.route.snapshot.data.hasOwnProperty('bannerJson')) {
      var args = "";
      if (this.route.snapshot.data["bannerJson"]["args"] != undefined && this.route.snapshot.data["bannerJson"].account_aware != undefined && this.route.snapshot.data["bannerJson"].account_aware) {
        this.baseService.getStorageFacility((faclityObj) => {
          if (faclityObj) {
            this.bannerJson.datasource['args'] = this.baseService.buildDyanamicStr(this.route.snapshot.data["bannerJson"]["args"], { data: faclityObj })
            this.getDataFn();
          }
        });

      } else {
        //TODO
      }

    }
  }

  getDataFn() {
    this.baseService.get(this.bannerJson.datasource.query_id, this.bannerJson.datasource['args'], this.bannerJson.datasource.resource, this.bannerJson.datasource.application).subscribe((data: any) => {
      console.log("data in response in banner detail is :: ", data);
      if (data.errCode == -1) {
        this.alerts.error(data.message);
      } else {
        if (data.resource && data.resource.length > 0) {
          data = data.resource[0];
          this.cardData = data;
          /********************ACCOUNT AWARE  *************/
          if (this.bannerJson.accountAware != undefined && this.bannerJson.accountAware.banner_key != undefined && data[this.bannerJson.accountAware.banner_key] != undefined && data[this.bannerJson.accountAware.banner_key]) {
            this.baseService.setAccountAwareFacilityID(data[this.bannerJson.accountAware.banner_key]);
          }
          /********************ACCOUNT AWARE  *************/

          this.patientResult.emit(data);
          if (this.bannerJson.name != undefined) {
            this.extractData();
          } else {
            this.dataForCard.push(this.cardData);
            console.log("Element is ", this.dataForCard);
            this.getCustomComponent();
          }
          //added so tht banner info can be accessed further
          this.commonService.setBanner(this.bannerJson, this.cardData);
        }

      }
      this.loader.hideSpinner();
    }, error => {
      console.log(error);
      this.alerts.error('API error');
      this.loader.hideSpinner();
    }
    )
  }
  getCustomComponent() {
    console.log("Custom ", this.customComponent);
    this.baseService.createComponent(this.bannerJson.selector, this.customComponent, (response: any) => {
      if (response.instance) {
        response.instance.dataForCard = this.dataForCard;
        //Added abannerJson is neended by emr to get data
        response.instance.bannerJson = this.bannerJson;
        console.log("Response is ", response);
        if (response.instance.footerLinksClick) {
          response.instance.footerLinksClick.subscribe(event => {
            this.footerLinksClick.emit({ event });
          });
        }
        if (response.changeDetectorRef != undefined) {
          response.changeDetectorRef.detectChanges();
        }
      }
    });
  }

  extractData() {
    var resource = this.cardData;
    // this.dataForCard = [];
    var card = {};
    card['fields'] = [];
    if (this.bannerFields != undefined) {
      this.bannerFields['fields'].forEach(a => {
        if (a['heading'] == 'title') {
          a['value'] = a['name'];
          card['title'] = a;
        } else if (a['heading'].toLowerCase() == 'image') {
          a['value'] = resource[a['name']];
          card['image'] = a;
        } else if (a['type'] != undefined && a['type'] == 'composite') {
          a['name'] = a['heading'].trim();
          a['value'] = this.evalValue(a['format'], resource);
          card['fields'].push(a);
        } else if (a['config'] && a['config'] != undefined) {
          card['buttonConfig'] = a;
        } else {
          a['value'] = resource[a['name']];
          card['fields'].push(a);
        }
      });
    }
    this.dataForCard.push(card);
    console.log("Element is ", this.dataForCard);
    this.getCustomComponent();
  }

  private evalValue(value: any, item: any) {
    if (value != undefined && item != undefined && eval(value)(item) != undefined) {
      return eval(value)(item);
    }
  }
  ngOnDestroy() {
    this.commonService.setBanner(null, null);
  }

}
